/**
 * WebViewModal — Modal that hosts a `WebView` iframe. Used for legal
 * pages (Manifesto / Terms / Privacy) and any other in-context external
 * page that should stay inside the app shell instead of a new tab.
 */

import Modal from './Modal';
import WebView from './WebView';

interface Props {
  visible: boolean;
  onClose: () => void;
  url: string;
  title: string;
  /** Iframe height inside the modal. Defaults to 70vh. */
  height?: number | string;
}

const WebViewModal: React.FC<Props> = ({
  visible,
  onClose,
  url,
  title,
  height = '70vh',
}) => {
  return (
    <Modal visible={visible} onClose={onClose} title={title}>
      <div
        style={{
          width: '100%',
          height: typeof height === 'number' ? `${height}px` : height,
          borderRadius: 12,
          overflow: 'hidden',
          background: 'rgba(0,0,0,0.2)',
        }}
      >
        <WebView source={{ uri: url }} title={title} />
      </div>
    </Modal>
  );
};

export default WebViewModal;
